/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateTBankSBPPaymentMutationRequest, CreateTBankSBPPaymentMutationResponse, CreateTBankSBPPayment400, CreateTBankSBPPayment401, CreateTBankSBPPayment404, CreateTBankSBPPayment500 } from "../entities/CreateTBankSBPPayment";

function getCreateTBankSBPPaymentUrl() {
  const res = { method: 'POST', url: `/api/v1/payments/sbp` as const }
  return res
}

/**
 * @description Создает новый платеж через платежную систему T-Bank.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Минимальная сумма платежа: 120 RUB
 * - Максимальная сумма платежа: 9000 RUB
 * - Максимальная длина description: 140 символов
 * **Процесс:**
 * 1. Валидация входных данных
 * 2. Создание записи в БД
 * 3. Отправка запроса в T-Bank API
 * 4. Возврат URL для оплаты
 * @summary Инициализация платежа через T-Bank для СБП
 * {@link /api/v1/payments/sbp}
 */
export async function createTBankSBPPayment(data: CreateTBankSBPPaymentMutationRequest, config: Partial<RequestConfig<CreateTBankSBPPaymentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateTBankSBPPaymentMutationResponse, ResponseErrorConfig<CreateTBankSBPPayment400 | CreateTBankSBPPayment401 | CreateTBankSBPPayment404 | CreateTBankSBPPayment500>, CreateTBankSBPPaymentMutationRequest>({ method : "POST", url : getCreateTBankSBPPaymentUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}